import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import { ThemeProvider } from "./ThemeContext";
import ThemeToggle from "./components/ThemeToggle/ThemeToggle";
import "./locales/i18n";
import { setNavigator, setCurrentPath } from "./Utils/errorUtils";
import AuthProvider from "./Utils/AuthProvider";
import ScrollProgress from "./Utils/ScrollProgress";
import RouteComponent from './RouteComponent';
import Footer from "./components/User/Footer/Footer";
import ReactGA from 'react-ga4';
import 'leaflet/dist/leaflet.css';
import { LoaderProvider } from "./Utils/LoaderContext";
import Loader from "./Utils/Loader";

ReactGA.initialize('G-09XZCQYR7E');

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdministrator = location.pathname.startsWith("/admin/administrator");
  const isAdminRoute = location.pathname.startsWith("/admin");
  useEffect(() => {
    setNavigator(navigate); //set navigation
  }, [navigate]);

  useEffect(() => {
    setCurrentPath(location.pathname); // set current path
  }, [location.pathname]);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  ReactGA.event({
    category: 'User',
    action: 'Clicked Some Button',
    label: 'My CTA Button'
  });
  return (
    <AuthProvider>
      <LoaderProvider>
        <Loader />
        <ThemeProvider>
          <ThemeToggle />
          {!isAdminRoute && <Navbar />}
          <RouteComponent />
          {!isAdminRoute && <ScrollProgress />}
          {!isAdminRoute && <Footer />}
        </ThemeProvider>
      </LoaderProvider>
    </AuthProvider>
  );
};

export default App;
